import React from "react";
import { Box, Grid, Typography, Stack, Paper } from "@mui/material";
import { aws, screen, python } from "../../assets";

const DataMonitoring = () => {
  return (
    <Box
      component="section"
      id="monitoring"
      sx={{
        py: 10,
        position: "relative",
      }}
    >
      <Grid
        container
        spacing={6}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Screenshot / Hardware visual */}
        <Grid item xs={12} md={6}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 4,
              overflow: "hidden",
              bgcolor: "transparent",
            }}
          >
            <Box
              component="img"
              src={screen}
              alt="Fuel Pro Monitoring"
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Paper>
        </Grid>

        {/* Copy */}
        <Grid item xs={12} md={6}>
          <Stack spacing={3}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                fontFamily: "Poppins, sans-serif",
                color: "#fff",
              }}
            >
              Monitor & Store Critical Tank Data with Confidence
            </Typography>

            <Typography
              variant="h4"
              sx={{
                maxWidth: 500,
                color: "rgba(226,232,240,0.8)",
              }}
            >
              Fuel Pro continuously tracks level, water, alarms, meter totals,
              deliveries, and more — all monitored in real time and stored
              securely in the cloud. Our sensor logic and polling intervals
              guarantee consistent and trustworthy readings.
            </Typography>

            <Stack direction="row" spacing={3} mt={2}>
              <Box
                component="img"
                src={aws}
                alt="AWS Powered"
                sx={{ height: 42, opacity: 0.85 }}
              />
              <Box
                component="img"
                src={python}
                alt="Python Powered"
                sx={{ height: 42, opacity: 0.85 }}
              />
            </Stack>
          </Stack>
        </Grid>
      </Grid>

      {/* Background gradients */}
      <Box
        sx={{
          position: "absolute",
          zIndex: 0,
          left: "-25%",
          top: "10%",
          width: "45%",
          height: "60%",
        }}
        className="white__gradient"
      />
      <Box
        sx={{
          position: "absolute",
          zIndex: 0,
          left: "-20%",
          bottom: "10%",
          width: "45%",
          height: "60%",
        }}
        className="pink__gradient"
      />
    </Box>
  );
};

export default DataMonitoring;
